import styled from 'styled-components'

function BaseArrowDownwardIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z" fill="currentColor" />
    </svg>
  )
}

export const ArrowDownwardIcon = styled(BaseArrowDownwardIcon)``
